import React, { useContext, useCallback } from "react";

import { Auth } from "api/makeApiRequest";
import ModalConfirm from "components/ModalConfirm";
import { AuthContext } from "components/AuthProvider/AuthProvider";
import { useSendData } from "hooks/useSendData";
import { markMeetingPaid } from "api/markMeetingPaid";
import { ApiRequest } from "api/makeApiRequest/ApiRequest";

import { ModalMarkPaidContents } from "./ModalMarkPaid.styles";

interface Props<T extends { id: string }> {
	item: T | undefined;
	itemDescription: string;
	markPaid: (data: T, auth: Auth) => ApiRequest<{}>;
	isOpen: boolean;
	onCancel: () => Promise<void>;
	onOK: () => Promise<void>;
	summary: (item: T, uid: string) => React.ReactNode;
}

function ModalMarkPaid<T extends { id: string }>({
	item,
	itemDescription,
	isOpen,
	onCancel,
	onOK,
	summary
}: Props<T>) {
	const [{ uid }] = useContext(AuthContext);

	const doMarkPaid = useSendData({ method: markMeetingPaid });

	const { id } = item ? item : { id: undefined };
	const handleOK = useCallback(async () => {
		if (!id) {
			return;
		}

		await doMarkPaid(
			{
				id
			},
			{ uid }
		).ready;

		await onOK();
	}, [id, doMarkPaid, onOK, uid]);

	if (!uid) {
		return null;
	}

	if (!item) {
		return null;
	}

	return (
		<ModalConfirm
			isOpen={!!item}
			title={`Mark ${itemDescription} paid - please confirm`}
			onCancel={onCancel}
			onOK={handleOK}
			okText="Yes please"
		>
			<ModalMarkPaidContents>{summary(item, uid)}</ModalMarkPaidContents>
		</ModalConfirm>
	);
}

export default ModalMarkPaid;
